import { Injectable, EventEmitter } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, tap, map } from "rxjs/operators";
import { GlobalsService } from "./globals";
import { Observable, of, throwError } from "rxjs";
import { Documents } from "../models/documents-class";
import { folderCreation } from "../../shared/models/folder-class";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class DocumentsCrudService {
  public onClickDocument$: EventEmitter<Array<any>>;

  constructor(private http: HttpClient, private globals: GlobalsService) {
    this.onClickDocument$ = new EventEmitter<Array<any>>();
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`${operation} failed: ${error.message}`);
      if (error.error.message == "Token is invalid!") {
        localStorage.removeItem("token");
      } else {
        return throwError(error);
      }
      return of(result as T);
    };
  }

  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: "Bearer " + this.globals.user.token,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  }
  searchDocs(str: string): Observable<any> {
    var uri = `/api/recurso/all?criterio=${str}`;
    var res = encodeURI(uri);
    const url = `${this.globals.apiUrl}${res}`;
    console.log("req",url);
    
    return this.http.get(url, {
      headers: this.header(),
    });
  }
  getDocuments(): Observable<Documents[]> {
    return this.http
      .get<Documents[]>(`${this.globals.apiUrl}/api/recurso`)
      .pipe(
        tap((Documents) => console.log("fetched Documents")),
        catchError(this.handleError("getDocuments", []))
      );
  }
  getDocumentsById(id: string): Observable<Documents> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}/list`;
    return this.http.get<Documents>(url).pipe(
      tap((_) => console.log(`fetched documents id=${id}`)),
      catchError(this.handleError<Documents>(`getDocumentsById id=${id}`))
    );
  }
  addDocuments(documents: folderCreation): Observable<any> {
    const apiUrl = `${this.globals.apiUrl}/api/recurso`;
    return this.http.post<any>(apiUrl, documents, httpOptions).pipe(
      tap((c: folderCreation) => console.log(`added product w/ id=${c}`)),
      catchError(this.handleError<any>("addDocuments"))
    );
  }

  updateDocuments(id: string, documents: folderCreation): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/${id}`;
    return this.http.put(url, documents, httpOptions).pipe(
      tap((_) => console.log(`updated documents id=${id}`)),
      catchError(this.handleError<any>("updateDocuments"))
    );
  }

  public deleteDocuments(doc) {
    console.log(doc);
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: {
        recurso_nuevo_id: [],
      },
    };

    options.body.recurso_nuevo_id.push(doc);

    return this.http.delete(
      `${this.globals.apiUrl}/api/recurso/descartar-recurso`,
      options
    );
  }
  public deleteDocumentsAp(body) {
    const apiUrl = `${this.globals.apiUrl}/api/recurso/marcar-descartar/aprobados`;
    return this.http.post<any>(apiUrl, body, httpOptions).pipe(
      tap((c: any) => console.log(`added doc w/ id=${c}`)),
      catchError(this.handleError<any>("importDocuments"))
    );
  }
  getVisuals(tb): Observable<any> {
    return this.http.get(
      `${this.globals.apiUrl}/api/organizacion/toolbox/${tb}/nivel/4/usuario `,
      {
        headers: this.header(),
      }
    );
  }
  getModif(tb): Observable<any> {
    return this.http.get(
      `${this.globals.apiUrl}/api/organizacion/toolbox/${tb}/nivel/5/usuario `,
      {
        headers: this.header(),
      }
    );
  }
  getApprovers6(): Observable<any> {
    return this.http.get(
      `${this.globals.apiUrl}/api/organizacion/toolbox/5/nivel/6/usuario `,
      {
        headers: this.header(),
      }
    );
  }

  get_link_processes(resource): Observable<any> {
    return this.http.get(
      `${this.globals.apiUrl}/api/recurso/${resource}/enlace`,
      {
        headers: this.header(),
      }
    );
  }

  public link_processes(resource, data): Observable<any> {
    return this.http.post(
      `${this.globals.apiUrl}/api/recurso/${resource}/enlace`,
      data
    );
  }

  getOneDoc(id): Observable<any> {
    return this.http.get(`${this.globals.apiUrl}/api/recurso/${id}`, {
      headers: this.header(),
    });
  }
  getUnnaprovedNew(): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/recurso-devuelto-nuevo`;
    return this.http.get(url, {
      headers: this.header(),
    });
  }
  getUnnaprovedMod(): Observable<any> {
    const url = `${this.globals.apiUrl}/api/recurso/recurso-devuelto-modificado`;
    return this.http.get(url, {
      headers: this.header(),
    });
  }

  getPermiso(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/permiso/${id}/verificar-permiso`,
      {
        headers: this.header(),
      }
    );
  }
}
